import React, { useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { buildEditorApiPayload } from './buildEditorApiPayload';

/** Save payload plus identifiers for inspection. */
function buildDefinitionObject(question) {
    if (!question) return {};
    return {
        id: question.id,
        unique_id: question.unique_id,
        owner_unique_id: question.owner_unique_id,
        ...buildEditorApiPayload(question),
    };
}

export function JsonDefinitionModal({ open, question, onClose }) {
    const text = useMemo(
        () => JSON.stringify(buildDefinitionObject(question), null, 2),
        [question]
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            scroll="paper"
        >
            <DialogTitle>Question definition (JSON)</DialogTitle>
            <DialogContent dividers>
                <Box
                    component="pre"
                    sx={{
                        m: 0,
                        p: 2,
                        typography: 'body2',
                        fontFamily: 'ui-monospace, monospace',
                        fontSize: 12,
                        lineHeight: 1.5,
                        overflow: 'auto',
                        maxHeight: '70vh',
                        bgcolor: 'grey.100',
                        borderRadius: 1,
                    }}
                >
                    {text}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
